import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { StaticMap } from 'components/Cartography'
import CardPreview, {
  CardBlockInfo,
  CardBody,
  CardHeader,
} from 'packages/ui/CardPreview'
import { Stack, Typography, Box } from '@mui/material'

import CardActionButton from 'components/global/CardActions/CardActionButton'
import useLink from '../../hooks/use-link'

const Header = ({ data }) => {
  const { t } = useTranslation()
  const apiLink = useLink()

  return (
    <CardHeader>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <Typography
          fontSize={14}
          fontWeight={600}
          color="#454545"
        >
          {t('audin_document.card_details.report', { number: data.id })}
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 1,
          }}
        >
          <Typography
            fontSize={12}
            fontWeight={600}
            color="#888888"
          >
            {data.site_name}
          </Typography>
          <Typography
            fontSize={12}
            color="#5D5D5D"
          >
            {t('audin_document.card_details.created_at', { date: data.created_at })}
          </Typography>
          {data && data.step === 'validated' && (
            <CardActionButton
              style={{
                padding: '8px',
                border: '1px solid #F0F0F0', borderRadius: '8px'
              }}
              tooltiptitle={t('audin_document.card_details.consult')}
              iconlabel={'fa-light fa-arrow-up-right'}
              onClick={async () => await apiLink.go(data.id)}
            />
          )}
        </Box>
      </Box>
    </CardHeader>
  )
}

const Body = ({ data, positions }) => {
  const { t } = useTranslation()

  return (
    <CardBody>
      <Stack flexDirection={'column'} gap={2} sx={{ width: '100%', marginBottom: '20px' }}>
        <StaticMap positions={positions} />

        <CardBlockInfo
          title={t('audin_document.card_details.address')}
          subtitle={data.site.full_address}
          titleStyles={{ fontWeight: 500, fontSize: 10, color: '#888888' }}
          subtitleStyles={{ fontWeight: 400, fontSize: 14, color: '#5D5D5D' }}
          gap={0.5}
        />
      </Stack>
    </CardBody>
  )
}

const Card = ({ data, onClose }) => {
  const { t } = useTranslation()
  const positions = useMemo(() => {
    return [
      {
        lat: data.site.location.latitude,
        lng: data.site.location.longitude,
      },
    ]
  }, [data])

  return (
    <CardPreview
      title={t('ui_elements.card_title')}
      onClose={onClose}
    >
      <Header data={data} />
      <Body data={data} positions={positions} />
    </CardPreview>
  )
}

export default Card
